import parsePhoneNumber from "libphonenumber-js";

export function formatPhoneUS(phoneString) {
    let phoneGroups = phoneString
        .replace('+1', '')
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    let phone = '';

    if (phoneGroups[1]) {
        phone += phoneGroups[2] ? '(' + phoneGroups[1] + ') ' : phoneGroups[1];
    }

    phone += phoneGroups[2];
    phone += phoneGroups[3] ? '-' + phoneGroups[3] : '';

    return phone;
}

export const getPlainPhone = (phoneString) => {
    let phoneGroups = phoneString
        .replace('+1', '')
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

    return phoneGroups[0] ? phoneGroups[0] : '';
};

export function formatStringPhoneUS(phoneString) {
    let formattedPhoneNumber = phoneString;
    const phoneNumber = parsePhoneNumber(phoneString, 'US');

    // If phoneNumber is undefined, then parsePhoneNumber can't parse specified phone string
    if (phoneNumber !== undefined) {
        formattedPhoneNumber = phoneNumber.formatNational();
    }

    return formattedPhoneNumber;
}